/**
 * Copies the automation's communication for a fixture, and goes to the copy to be finished.
 * Resolves to whether it went there; throws when the service fails.
 */
export async function prepareAutomationCommunication({
  automationId,
  dispatch = null,
  fixtureId,
  navigate,
}: {
  /** Ids as the rows hold them, which are not typed. */
  automationId: unknown;
  dispatch?: null;
  fixtureId: unknown;
  navigate?: (to: string) => void;
}) {
  // Loaded here, so the automation service isn't pulled in by whatever imports the rules.
  const { PrepareAutomationFixture } = await import("../automationService");
  const result = await PrepareAutomationFixture(dispatch, fixtureId, automationId);

  if (result?.response || result?.status >= 400) {
    throw result;
  }

  const communicationId = result?.data?.CopiedCommunicationId;

  if (communicationId) {
    const url = `/email-communication?id=${communicationId}`;

    if (navigate) {
      navigate(url);
    } else {
      window.location.assign(url);
    }

    return { communicationId, redirected: true, result };
  }

  return { communicationId: "", redirected: false, result };
}
